import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12.25,23.74a1.44,1.44,0,0,1-.36-2l6.58-9.47a.47.47,0,0,0,0-.55L11.89,2.26a1.43,1.43,0,0,1,.36-2,1.42,1.42,0,0,1,2,.36l6.59,9.46a3.33,3.33,0,0,1,.6,1.92,3.38,3.38,0,0,1-.6,1.92l-6.59,9.46A1.44,1.44,0,0,1,12.25,23.74Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M7.53.89l6.58,9.46a2.91,2.91,0,0,1,0,3.29L7.53,23.11a1,1,0,0,1-.79.41H3.53A1,1,0,0,1,2.67,23a1,1,0,0,1,.07-1l6.58-9.46a1,1,0,0,0,0-1.1L2.74,2a1,1,0,0,1-.07-1A1,1,0,0,1,3.53.48H6.74A1,1,0,0,1,7.53.89Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }